// extracted by mini-css-extract-plugin
export var con = "story-module--con--2Tl49";
export var imgDiv = "story-module--imgDiv--2XtsT";